import { SubscriptionEntry } from './SubscriptionEntry'; 

export const SubscriptionEntries = ({ subscriptions }) => {
    return (
        <div>
            <table className="table table-striped table-bordered my-2">
                <thead className="thead-dark">
                    <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Created</th>
                        <th scope="col">Quantity</th>
                        <th scope="col">
                            Enabled
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {subscriptions.map((value) => {
                        return <SubscriptionEntry key={value.subscriptionId} subscription={value} />
                    })
                    }
                </tbody>
            </table>           
        </div>
    )
}